export default __webpack_public_path__ + "static/media/eb-pro-wht-banner-2.78b7afa2.jpg";